<template>
  <v-card
    elevation="3"
  >
    <v-card-title class="d-flex justify-space-between align-start mb-0 pb-3">
      <div>
        <h2>Order details</h2>
        <v-breadcrumbs
          class="mb-0 pb-0 ml-0 pl-0 pt-1"
          :items="breadcrumbs"
        />
      </div>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-btn
            v-if="order.status == ORDER_ACTIVE"
            color="red"
            dark
            :loading="loading.finishBtn"
            @click="openFinishDialog"
          >
            Finish order
          </v-btn>
          <order-finish-dialog
            v-model="showFinishDialog"
            class="mr-2 mt-2 mb-2"
            :order="order"
            @complete="update"
            @close="showFinishDialog = false"
          />
          <v-btn
            v-if="showTakeBtn"
            dark
            class="mr-2 mt-2 mb-2"
            color="green"
            :loading="loading.take"
            @click="take(order.inner_id)"
          >
            Take order
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3>Main info</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Client’s Order ID</td>
              <td>{{ order.id }}</td>
            </tr>
            <tr>
              <td>Internal Order ID</td>
              <td>{{ order.inner_id }}</td>
            </tr>
            <tr>
              <td>Order status</td>
              <td>
                <order-status
                  v-if="order.status"
                  :value="parseInt(order.status)"
                  :wait-start="isWaitStartOrder"
                />
              </td>
            </tr>
            <tr>
              <td>Client</td>
              <td>
                <router-link :to="`/clients/details/${order.player_id}`">
                  {{ order.player_name }}
                </router-link>
              </td>
            </tr>
            <tr>
              <td>Creation time</td>
              <td>{{ order.creation_ts }}</td>
            </tr>
            <tr>
              <td>Start time</td>
              <td>{{ order.start_ts || '-' }}</td>
            </tr>
            <tr v-if="order.finish_reason">
              <td>Finish reason</td>
              <td>{{ order.finish_reason }}</td>
            </tr>
            <tr>
              <td>Rating</td>
              <td>
                <rating-star
                  v-if="order.rating"
                  :value="order.rating / 5"
                  :margin="3"
                  :step="20"
                  :size="15"
                  readonly
                />
                <span v-else>
                  -
                </span>
              </td>
            </tr>
            <tr>
              <td>Rating text</td>
              <td>
                <span v-if="order.rating_text">{{ order.rating_text }}</span>
                <span v-else>
                  -
                </span>
              </td>
            </tr>
            <tr>
              <td>Goal</td>
              <td>{{ goalName }}</td>
            </tr>
          </table>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <h3>Game info</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Name</td>
              <td>{{ order.game_name }}</td>
            </tr>
            <tr>
              <td>Coach type</td>
              <td>{{ order.coach_type_text }}</td>
            </tr>
            <tr>
              <td>Login client</td>
              <td>{{ order.platform_id }}</td>
            </tr>
            <tr>
              <td>Platform</td>
              <td>{{ platform.title }}</td>
            </tr>
          </table>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <h3>Payment info</h3>
          <table class="info-user-tbl">
            <tr v-if="order.balance">
              <td>Client’s balance</td>
              <td>
                <span>
                  ${{ order.balance }}
                </span>
              </td>
            </tr>
            <tr v-if="order.timer">
              <td>Timer</td>
              <td>
                <span>
                  {{ convertTimer(order.timer) }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Reported time</td>
              <td>
                {{ order.reported_time || '-' }}
              </td>
            </tr>
            <tr>
              <td>Price, per hour</td>
              <td>{{ order.price_per_hour ? `$${order.price_per_hour}` : '-' }}</td>
            </tr>
            <tr>
              <td>Total price</td>
              <td>
                {{ order.total_price ? `$${order.total_price}` : '-' }}
              </td>
            </tr>
            <tr>
              <td>Coach commission</td>
              <td>
                {{ order.coach_commission ? `$${order.coach_commission}` : '-' }}
              </td>
            </tr>
            <tr>
              <td>TIPs</td>
              <td>
                {{ order.tips ? `$${order.tips}` : '-' }}
              </td>
            </tr>
            <tr v-if="order.max_duration && order.status === ORDER_ACTIVE">
              <td>Max duration</td>
              <td>
                {{ order.max_duration ? order.max_duration : '-' }}
              </td>
            </tr>
          </table>
        </v-col>
      </v-row>

      <v-row
        v-if="team.length > 0"
        class="mt-2"
      >
        <v-col cols="12">
          <h3>Team</h3>
          <div class="team-list">
            <div
              v-for="item in team"
              :key="item.id"
              class="team-item"
              @click="openDetailTeam(item.id, item.is_player)"
            >
              <div class="team-item__avatar">
                <img
                  v-if="item.avatar"
                  :src="item.avatar"
                >
                <div v-else>
                  <i class="icon icon-user" />
                </div>
              </div>
              <div class="team-item__info coach">
                <div class="coach__name">
                  {{ item.name }}
                </div>
                <div
                  v-if="item.kd"
                  class="coach__kd"
                >
                  KD {{ item.kd }}
                </div>
                <div
                  v-if="item.is_player"
                  class="coach__is-player"
                >
                  Client
                </div>
                <rating-star
                  v-if="item.rating"
                  :value="item.rating / 5"
                  :margin="3"
                  :step="20"
                  :size="15"
                  readonly
                />
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12">
          <h3>Chat</h3>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col>
          <div class="chat-wrapper">
            <z-chat
              ref="chat"
              :messages="chat"
              :allow-send="chatEnabled"
              @send="sendMessage"
            />
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog
      v-model="cancelledDialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Attention
        </v-card-title>
        <v-card-text>
          The order has been cancelled. Press OK to return to the order list.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="$router.push('/orders/list/current')"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import RatingStar from '@/components/app/RatingStar.vue';
import ZChat from '@/components/app/ZChat.vue';
import { goalList, orderStatuses, platformList } from '@/config';
import OrderStatus from '@/components/app/statuses/OrderStatus.vue';
import ordersAPI from '../../api/orders';
import OrderFinishDialog from './OrderFinishDialog.vue';

export default {
  components: {
    RatingStar,
    ZChat,
    OrderStatus,
    OrderFinishDialog,
  },
  data: () => ({
    ...orderStatuses,
    platformList,

    cancelledDialog: false,
    showFinishDialog: false,

    loading: {
      init: false,
      take: false,
      finishBtn: false,
    },

    updateInterval: null,

    allowSendChat: true,

    order: {
      chat: [],
    },

    chat: [],

    ws: null,

    breadcrumbs: [
      { text: 'Orders list', to: '/orders/list/current' },
      { text: 'Details', disabled: true },
    ],
  }),

  computed: {
    ...mapGetters({
      token: 'token',
    }),

    chatEnabled() {
      return this.allowSendChat && this.order.status === this.ORDER_ACTIVE;
    },

    goalName() {
      if (!this.order.goal_id) return '-';
      return goalList.find((item) => item.value === this.order.goal_id).label;
    },

    team() {
      if (!this.order.team) return [];
      const result = this.order.team.slice().sort((a) => (a ? -1 : 1));
      return result;
    },

    showTakeBtn() {
      return !this.order.couch_confirmed && this.order.status === this.ORDER_NEW;
    },

    isWaitStartOrder() {
      return this.order.couch_confirmed && this.order.status === this.ORDER_NEW;
    },

    platform() {
      if (!this.order.platform_type) return '-';
      // eslint-disable-next-line eqeqeq
      return this.platformList.find((item) => item.id == this.order.platform_type);
    },
  },

  async created() {
    await this.getDetails();
    this.updateInterval = setInterval(this.update, 10000);
    document.addEventListener('visibilitychange', this.checkVisiblePage, false);

    // chat init
    const { id } = this.$route.params;
    this.ws = new WebSocket(`wss://player.zeyplay.com/ws?token=${this.token}&orderId=${id}`);
    this.ws.onmessage = this.onmessage;
    this.ws.onerror = () => {
      this.$toast.error('Failed to connect chat with players, please try again later');
      this.allowSendChat = false;
    };
    this.$refs.chat.scrollBottom();
  },

  beforeDestroy() {
    clearInterval(this.updateInterval);
    document.removeEventListener('visibilitychange', this.checkVisiblePage, false);
  },

  methods: {
    checkVisiblePage() {
      if (document.visibilityState === 'visible') {
        this.update();
      }
    },

    async openFinishDialog() {
      this.loading.finishBtn = true;
      try {
        await this.getDetails(true, { need_chat: false });
        this.showFinishDialog = true;
      } catch (err) {
        throw new Error(err);
      }
      this.loading.finishBtn = false;
    },

    getDetails(sync = false, options) {
      if (!sync) {
        this.loading.init = true;
      }
      const { id } = this.$route.params;
      return ordersAPI.details(id, options)
        .then((response) => {
          if (response.data.success) {
            // upd user data
            if (this.order.status === this.ORDER_NEW
                  && response.data.data.order.status === this.ORDER_ACTIVE) {
              this.$store.dispatch('initUser');
            }

            // upd order data
            this.order = response.data.data.order;

            // upd chat data
            if (response.data.data.order.chat) {
              this.chat = response.data.data.order.chat;
            }

            // upd breadcrumbs data
            if (!sync) {
              this.breadcrumbs.push({ text: this.order.inner_id, disabled: true });
            }
          } else if (sync) {
            this.cancelledDialog = true;
          } else {
            this.$router.push('/orders/list/current');
          }
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    take(id) {
      this.loading.take = true;
      ordersAPI.take(id)
        .then((response) => {
          if (response.data.success) {
            this.getDetails(true);
          }
        })
        .finally(() => {
          this.loading.take = false;
        });
    },

    onmessage(event) {
      const response = JSON.parse(event.data);
      this.chat.push(response.data);
      this.$refs.chat.scrollBottom();
    },

    sendMessage(message) {
      this.ws.send(message);
    },

    update() {
      this.getDetails(true, { need_chat: false });
    },

    convertTimer(timer) {
      const hour = Math.trunc(((timer / 60) / 60) % 60);
      const minutes = Math.trunc((this.order.timer / 60) % 60);
      return `${hour}H ${minutes}M`;
    },

    openDetailTeam(id, isClient) {
      if (!isClient) return null;
      this.$router.push(`/clients/details/${id}`);

      const button = {
        show: true,
        type: 'link', // node // youtube,
        value: 'http://....', // node_id, youtube_link
      };

      console.log(button);
    },

  },
};
</script>

<style lang="scss" scoped>
h3 {
  color: #000;
  margin-bottom: 5px;
}

.player-name {
  margin-left: 20px;

  h1 {
    color: #000;
    margin-bottom: 5px;
  }

  span {
    font-size: 18px;
  }
}

.info-user-tbl {
  td {
    padding: 5px 0;
    font-size: 16px;

    &:first-child {
      font-weight: bold;
      padding-right: 20px;
    }
  }
}

.team-list {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.team-item {
  min-width: 180px;
  padding: 10px;
  background: rgb(243, 243, 243);
  margin-right: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  &__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgb(97, 97, 97);
    margin-right: 10px;

    .icon {
      font-size: 24px;
      position: relative;
      top: 3px;
      color: #9c9c9c;
      opacity: 0.7;
    }

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .coach {
    &__name {
      font-weight: 600;
    }

    &__kd {
      font-size: 12px;
    }

    &__is-player {
      font-size: 12px;
      background: var(--color-secondary);
      color: var(--color-white);
      display: inline;
      border-radius: 3px;
      padding: 3px 8px;
    }
  }
}

.chat-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: #f9f9f9;
}

</style>
